import { useI18n } from "@wojo/localization";
import { Button, Text } from "@wojo/ui";
import React from "react";
import { useTripBuilder } from "../context/TripBuilderContext";
import { formatDepartureStartAndEndDates } from "../hooks/format-departure-start-and-end-dates";
import styles from "../trip-builder-quote-step/TripBuilderQuoteStep.module.scss";

export type QuoteDepartureDateProps = {
    departureDate?: string;
    endDate?: string;
};

export const SectionDepartureDates: React.FC<QuoteDepartureDateProps> = ({
    departureDate,
    endDate,
}) => {
    const { setDepartureId, gcDeparture, departure } = useTripBuilder();
    const { productPage } = useI18n("productPage");

    return (
        <Text.Body emphasis="2" className={styles.date}>
            <span
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "var(--g-spacing-sm)",
                }}
                data-testid="quote-departure-date"
            >
                {formatDepartureStartAndEndDates(
                    departureDate ? departureDate : departure?.departureDate,
                    endDate ? endDate : departure?.endDate,
                )}
                {!gcDeparture && (
                    <Button
                        variant="quiet"
                        type="button"
                        onClick={() => {
                            setDepartureId(null);
                        }}
                    >
                        {productPage.tripBuilder.quote.backLabel.l()}
                    </Button>
                )}
            </span>
        </Text.Body>
    );
};
